const Main = ({ id = "main", className = "main", children, ...otherProps }) => {
    return (
        <main id={id} className={className} {...otherProps}>
            {children}
        </main>
    );
};

export default Main;